import type { HTMLAttributes } from "react";
import { motion, type MotionProps } from "framer-motion";
import { cn } from "@/shared/lib/cn";

export type ModalProps = HTMLAttributes<HTMLDivElement> &
	MotionProps & {
		isOpen: boolean;
		onClose?: () => void;
	};

export const Modal = ({ isOpen, onClose, className, children, ...props }: ModalProps) => {
	if (!isOpen) return null;

	return (
		<motion.div
			className="fixed inset-0 z-120 flex items-center justify-center px-[16px] md:px-0"
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<div className="absolute inset-0 bg-dim-strong backdrop-blur-[2px]" onClick={onClose} />
			<motion.div
				className={cn("z-140 max-w-[calc(100vw-32px)]", className)}
				initial={{ scale: 0.95, opacity: 0 }}
				animate={{ scale: 1, opacity: 1 }}
				exit={{ scale: 0.95, opacity: 0 }}
				{...props}
			>
				{children}
			</motion.div>
		</motion.div>
	);
};
